import resources from './base';
import { AUCTIONS_CATALOG_ID } from '../consts';

export default resources(`finished/auctions_catalogs/${AUCTIONS_CATALOG_ID}/artworks`);



// WEBPACK FOOTER //
// ./app/javascript/packs/auctions_catalogs/show/resources/artworks.js